import {useCallback} from 'react';

import {
  trackEvent,
  TrackingTypesEnum,
} from '../../../../../../../libs/shared/core/src/services/tracking/tracking';
import {IntegrationFileAttachment} from '../../../../../../helpers/integrationHelpers';
import {IntegrationModel} from '../../../../../../models/api/integrationModel';
import {useDriveAttachments} from './driveAttachmentsHook';
import {useDropboxAttachments} from './dropboxAttachmentsHook';

export function useIntegrationAttachments(
  onIntegrationAttachLinks: (arg: ReadonlyArray<IntegrationFileAttachment>) => void,
) {
  // Integration-specific hooks.
  const {showDropboxAttachmentsPicker} = useDropboxAttachments(onIntegrationAttachLinks);
  const {showDriveAttachmentsPicker} = useDriveAttachments(onIntegrationAttachLinks);

  // General picker function.
  const showIntegrationAttachmentsPicker = useCallback(
    (integration: IntegrationModel) => {
      trackEvent(TrackingTypesEnum.COMPOSER_INTEGRATION, integration.type, {action: 'attach-clicked'});
      switch (integration.type) {
        case 'dropbox':
          return showDropboxAttachmentsPicker();

        case 'googledrive':
          return showDriveAttachmentsPicker(integration);

        default:
          throw new Error(`No attachment integration could be found for type: ${integration.type}`);
      }
    },
    [showDriveAttachmentsPicker, showDropboxAttachmentsPicker],
  );

  return {showIntegrationAttachmentsPicker};
}
